"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prebuiltWebToSms = void 0;
/* eslint-disable max-lines */
const templateUtils_1 = require("../../templateUtils");
const triggerFormContent = {
    subject: 'Web to SMS',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: '41112a7f-911a-4005-bcd7-d82c35320280',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/WebtoSms.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: 'd9724a75-068b-408b-8488-7d7dc5339573',
            data: {
                backgroundColor: '#ffffff',
                label: 'Mobile number',
                requiredField: true,
                helperText: 'You can enter multiple numbers separated by a semicolon. (E.g. 0400123456;0400123654)',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'tel',
            },
        },
        {
            type: 'form-text-area',
            version: '1',
            id: '340a81f7-d57d-4cc3-9d90-845b295608b7',
            data: {
                backgroundColor: '#ffffff',
                label: 'Message Content',
                requiredField: false,
                helperText: 'Long message content will be sent via multiple SMS messages automatically.',
                defaultValue: '',
                inputFieldHeight: 4,
                placeholder: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'form-submit-button',
            version: '1',
            id: 'cfd4f7f2-3c18-4d75-b8fe-2d6cd197a3b3',
            data: {
                backgroundColor: '#FFFFFF',
                borderColor: '#7F32DC',
                borderRadius: 4,
                buttonColor: '#7F32DC',
                color: '#FFFFFF',
                fontSize: 14,
                paddingBottom: 10,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 10,
                text: 'Send Message',
                textAlign: 'center',
                width: 600,
            },
        },
    ],
    inputVariables: [],
    outputVariables: [
        {
            id: 'd9724a75-068b-408b-8488-7d7dc5339573',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Mobile number',
        },
        {
            id: '340a81f7-d57d-4cc3-9d90-845b295608b7',
            valueType: 'string',
            inputType: 'form-text-area',
            label: 'Message Content',
        },
    ],
};
const prebuiltWebToSms = (workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        {
            id: 0,
            variables: {
                input: [],
                output: [
                    {
                        variableName: 'Mobile number',
                        variableId: 'd9724a75-068b-408b-8488-7d7dc5339573',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: 'Message Content',
                        variableId: '340a81f7-d57d-4cc3-9d90-845b295608b7',
                        variableType: 'string',
                        type: 'FormTextArea',
                    },
                ],
            },
            type: 'start',
            next: [
                {
                    id: 3478,
                    variables: {
                        input: [],
                        output: [],
                    },
                    type: 'task',
                    action: 'send-sms',
                    next: null,
                    isDirty: true,
                    version: '1.0.4',
                    data: {
                        workspaceId,
                        recipients: [
                            {
                                type: 'variable',
                                stepId: '0',
                                variableId: 'd9724a75-068b-408b-8488-7d7dc5339573',
                            },
                        ],
                        message: {
                            content: {
                                type: 'raw',
                                subject: '<p>Web to SMS Message</p>',
                                body: '<p><span data-stepid="0" data-variableid="340a81f7-d57d-4cc3-9d90-845b295608b7">Message Content</span> </p>',
                            },
                            type: 'sms',
                        },
                        link: null,
                        collectResponses: false,
                        stepName: 'Web to SMS Message',
                    },
                },
            ],
            isDirty: true,
            version: '1.0.2',
            data: {
                stepName: 'Trigger',
                triggers: [
                    {
                        id: 0,
                        type: 'form',
                        data: {
                            form: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, triggerFormContent), { workspaceId })); }),
                            }),
                        },
                    },
                ],
            },
        },
    ];
});
exports.prebuiltWebToSms = prebuiltWebToSms;
//# sourceMappingURL=webToSms.js.map